import { computed, ref } from "vue"

// let knows how many <PageTitle> instances are currently mounted
const mountedCount = ref(0)

const isPresent = computed(() => mountedCount.value > 0)

export const usePageTitlePresence = () => {
  const register = (): void => {
    mountedCount.value++
  }

  const unregister = (): void => {
    mountedCount.value = Math.max(0, mountedCount.value - 1)
  }

  return { isPresent, register, unregister }
}
